module.exports = __webpack_public_path__ + "img/circle_main.a5374fb9.svg";